import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  CheckBoxColumn,
  ResultRowOrders,
} from '../../../NodeGroups/DTOrderSearch/Common/SearchResults/Common/DTOrderSearchResult/DTOrderSearchResult.styles';
import { ProductCheckbox } from '../../../NodeGroups/DTProductSearch/Common/ProductSearchResultsList/ProductSearchResultsList.styles';
import { StoreResultsColumn } from './StoreSearchResultsList.styles';
import { getSelectedRbiStore } from 'selectors/tools';
import { rbiSetSelectedStore } from '../../../../../actions/tools/RBIActions';

export const StoreSearchResultsList = (props) => {
  const { stores } = props;

  const dispatch = useDispatch();
  const selectedStore = useSelector(getSelectedRbiStore);

  const isChecked = (store) => selectedStore && store?._id === selectedStore?._id;

  const handleCheckboxClick = (store) => {
    if (isChecked(store)) {
      return dispatch(rbiSetSelectedStore(null));
    }

    return dispatch(rbiSetSelectedStore(store));
  };

  return (
    <>
      {stores.map((store) => {
        return (
          <ResultRowOrders key={store._id}>
            <CheckBoxColumn>
              <ProductCheckbox type="checkbox" checked={isChecked(store)} onChange={() => handleCheckboxClick(store)} />
            </CheckBoxColumn>
            <StoreResultsColumn>{store?.storeAddress?.address1}</StoreResultsColumn>
            <StoreResultsColumn>{store?.storeAddress?.city}</StoreResultsColumn>
            <StoreResultsColumn>{store?.storeAddress?.stateProvince}</StoreResultsColumn>
            <StoreResultsColumn>{store?.storeAddress?.postalCode}</StoreResultsColumn>
          </ResultRowOrders>
        );
      })}
    </>
  );
};
